import $http from '../../../axios-instance';

/**
 * Crear una nueva locación.
 *
 * @param {*} commit - Función de Vuex para llamar a una mutación.
 * @param {*} site - Locación.
 * @param {*} company_id - Identificador de la empresa.
 * @return {Promise<void>}
 * @author Brandon Torres
 */
export async function storeSite({ commit }, { site, company_id }) {
    commit("dashboard/load", true, { root: true });
    try {
        const response = await $http.post(
            `sites/create/${company_id}`,
            site
        );
        this.$vue.$alertSuccess(response.data.message);
        return true;
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return false;
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}

/**
 * Listar las locaciones.
 *
 * @param {*} commit - Función de Vuex para llamar a una mutación.
 * @param {*} state - Estado de Vuex.
 * @param {*} company_id - Identificador de la empresa.
 * @param {*} reloadPage - Recargar la página.
 * @return {Promise<void>}
 * @autor Brandon Torres
 */
export async function listSites(
    { commit, state },
    { company_id, reloadPage = false }
) {
    commit("dashboard/load", true, { root: true });
    try {
        const { page, per_page, search } = state.filterSites;

        const response = await $http.get(`sites/list/${company_id}`, {
            params: {
                page: reloadPage ? 1 : page,
                perPages: per_page,
                search: search,
            },
        });
        commit("setSites", response.data.data);
        commit("setPaginateSites", response.data.data);
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return false;
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}

/**
 * Cambiar el estado de la locación.
 *
 * @param {*} commit - Función de Vuex para llamar a una mutación.
 * @param {*} company_id - Identificador de la empresa.
 * @param {*} id - Identificador de la locación.
 * @return {Promise<void>}
 * @author Brandon Torres
 */
export async function changeStatusSite({ commit }, { company_id, id }) {
    commit("dashboard/load", true, { root: true });
    try {
        const response = await $http.put(
            `sites/change-status/${company_id}/${id}`
        );
        this.$vue.$alertSuccess(response.data.message);
    } catch (error) {
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}

/**
 * Cargar la locación segun su id.
 *
 * @param {*} commit - Función de Vuex para llamar a una mutación.
 * @param {*} company_id - Identificador de la empresa.
 * @param {*} id - Identificador de la locación.
 * @return {Promise<void>}
 * @author Brandon Torres
 */
export async function showSite({ commit }, { company_id, id }) {
    commit("dashboard/load", true, { root: true });
    try {
        const response = await $http.get(`sites/show/${company_id}/${id}`);
        commit("setSite", response.data.data);
    } catch (error) {
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}

/**
 * Actualizar la locación.
 *
 * @param {*} commit - Función de Vuex para llamar a una mutación.
 * @param {*} site - Locación.
 * @param {*} company_id - Identificador de la empresa.
 * @return {Promise<void>}
 * @author Brandon Torres
 */
export async function updateSite({ commit }, { site, company_id }) {
    commit("dashboard/load", true, { root: true });
    try {
        const response = await $http.put(
            `sites/update/${site.id}/${company_id}`,
            site
        );
        this.$vue.$alertSuccess(response.data.message);
        return true;
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return false;
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}

/**
 * Obtener todas las locaciones activas.
 *
 * @param {*} commit - Función de Vuex para llamar a una mutación.
 * @param {*} company_id - Identificador de la empresa.
 * @return {Promise<void>}
 * @autor Brandon Torres
 */
export async function getAllActive({ commit }, company_id) {
    commit("dashboard/load", true, { root: true });
    try {
        const response = await $http.get(`sites/all-active/${company_id}`);
        commit("setSitesActive", response.data.data);
    } catch (error) {
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}
